class AccessibleTabList {
  constructor(wrapper) {
    // Each instance only knows its own wrapper
    this.wrapper = wrapper;
    this.tablist = wrapper.querySelector('[role="tablist"]');
    // tabs and panels as instance variables – no more passing as parameters
    this.tabs = [...this.tablist.querySelectorAll('[role="tab"]')];
    this.panels = this.tabs.map((tab) =>
      document.getElementById(tab.getAttribute("aria-controls")),
    );

    // Order matters: enhancement first, then listeners
    this.enhance();
    this.addEventListeners();
  }

  enhance() {
    this.tabs.forEach((tab, index) => {
      const panel = this.panels[index];
      const isActive = tab.getAttribute("aria-selected") === "true";

      panel.setAttribute("role", "tabpanel");
      panel.setAttribute("aria-labelledby", tab.id);
      panel.setAttribute("tabindex", "0");

      tab.setAttribute("tabindex", isActive ? "0" : "-1");
    });

    this.wrapper.setAttribute("data-tabs-enhanced", "");
  }

  activateTab(newTab) {
    this.tabs.forEach((tab, index) => {
      const isNew = tab === newTab;
      tab.setAttribute("aria-selected", isNew ? "true" : "false");
      tab.setAttribute("tabindex", isNew ? "0" : "-1");

      this.panels[index].setAttribute("aria-hidden", isNew ? "false" : "true");
      this.panels[index].classList.toggle(
        "smart-tabs-content-block-active",
        isNew,
      );
      tab.classList.toggle("smart-tabs-navigation-li-active", isNew);
    });

    newTab.focus();
  }

  addEventListeners() {
    // Click handler directly on the tablist – Event Delegation
    this.tablist.addEventListener("click", (e) => {
      const tab = e.target.closest('[role="tab"]');
      if (tab) this.activateTab(tab);
    });

    this.tablist.addEventListener("keydown", (e) => {
      const currentIndex = this.tabs.indexOf(document.activeElement);
      let newIndex;

      switch (e.key) {
        case "ArrowRight":
        case "ArrowDown":
          newIndex = (currentIndex + 1) % this.tabs.length;
          break;
        case "ArrowLeft":
        case "ArrowUp":
          newIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
          break;
        case "Home":
          newIndex = 0;
          break;
        case "End":
          newIndex = this.tabs.length - 1;
          break;
        default:
          return;
      }

      e.preventDefault();
      this.activateTab(this.tabs[newIndex]);
    });

    this.tabs.forEach((tab) => {
      tab.addEventListener("focus", () => this.activateTab(tab));
    });
  }
}
